import { RadarChart as MuiRadarChart, RadarChartProps } from '@mui/x-charts';
import React from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import { useLocaleSeries } from 'components/charts/hooks/use-locale-series';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

const RadarChart = React.forwardRef<HTMLDivElement, RadarChartProps & ChartSurfaceProps>(function RadarChart({ dark, ...props }, ref) {
  const { formatValue } = useChartLocale();
  const series = useLocaleSeries(props.series, formatValue);

  return (
    <ChartThemeScope dark={dark}>
      <MuiRadarChart {...props} ref={ref} series={series} />
    </ChartThemeScope>
  );
});

export default RadarChart;
